import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatSelectChange } from "@angular/material/select";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatStepper } from "@angular/material/stepper";
import { Router } from "@angular/router";
import { IFormBuilder, IFormGroup } from "@rxweb/types";
import { CreatePayablesModalComponent } from "app/components/v1/create-payables-modal/create-payables-modal.component";
import { PayablesFromDatabaseModalComponent } from "app/components/v1/payables-from-database-modal/payables-from-database-modal.component";
import { UploadModalService } from "app/components/v1/upload-modal/upload-modal.service";
import { EnviarNotasModalComponent } from "app/components/v1/xml-modal/envio-notas-modal.component";
import { EnvioNotasModalService } from "app/components/v1/xml-modal/envio-notas-modal.service";
import { OperationData } from "app/components/v2/OperationSummary/operation-summary.component";
import { OperationSummaryService } from "app/components/v2/OperationSummary/operation-summary.service";
import { PayableListService } from "app/components/v2/PayableList/payable-list.service";
import { AuthService } from "app/core/auth/auth.service";
import { UserService } from "app/core/user/user.service";
import { CalculoService } from "app/modules/admin/v1/calcula-me/calculator.service";
import { ClientesService } from "app/modules/admin/v1/cedente/cedente.service";
import { Cedente } from "app/modules/admin/v1/cedente/interfaces/cedente.types";
import { AskWithoutPaymentSlipModalComponent } from "app/modules/admin/v1/operacoes/components/ask-without-payment-slip-modal/ask-without-payment-slip-modal.component";
import { IPayable } from "app/modules/admin/v1/operacoes/interfaces/payables.interface";
import { OperacoesService } from "app/modules/admin/v1/operacoes/operacoes.service";
import { DATE_FORMAT_REGEX } from "app/shared/constants/date-format-regex.constant";
import { OperationStatusEnum, PayableType } from "app/shared/constants/operation.enum";
import { EnumTypeDocument } from "app/shared/enums/type-document.enum";
import { FileValidator } from "app/shared/services/file-validator/file-validator.service";
import { adjustDateToEndOfDay } from "app/utils/adjust-date-to-end-of-day";
import { MAX_FILE_SIZE } from "app/utils/constants/file-size.constant";
import { compareAsc, parse } from "date-fns";
import { environment } from "environments/environment";
import { NgxDropzoneChangeEvent } from "ngx-dropzone";
import { Observable, of, Subject } from "rxjs";
import { debounceTime, takeUntil } from "rxjs/operators";
import { Operacao, OperacaoMode, Payable, TermsData } from "../../../v1/operacoes/operacoes.types";
import { BANK_SERVICE_TYPES, PAYABLE_TYPE_LIST, featureFlags } from "../constants";
import { FileType, IOperationTypes } from "../interfaces";
import { IOutputPayableError } from "../interfaces/output-payable-error.interface";
import messages from "../messages";
import { ChooseUploadFileModalComponent } from "../modals/chooseUploadFileModal/choose-upload-file-modal.component";
import { ConfirmTypePayableModalComponent } from "../modals/confirmTypePayableModal/confirm-type-payable-modal";
import { UploadBankCheckModalComponent } from "../modals/uploadBankCheckModal/upload-bank-check-modal.component";
import { FeesEnum } from "../types/fees.enum";
import { BasicInformation, FeesForm, FundingForm, PaymentForm } from "../types/form-types.interface";
import { IMinibankFees } from "../types/minibank-fees.interface";
import { ReceipientBankAccount } from "../types/receipiente-bank-account.interface";
import { BankAccountModalComponent } from "./components/bank-account-modal/bank-account-modal.component";
import {
    UnoperatedPayablesResponse,
    UnoperatedPayablesSelection,
} from "./components/repurchase-payables-modal/interfaces/unoperated-payables";
import { calculateFundingProfitability } from "./calculate-funding-profitability";
import { CreateOperationService } from "./create-operation.service";
import { buildFundingUsedChangePatch, splitDisbursementByFundingUsed } from "./split-disbursement-by-funding-used";
import { RepurchasePayableService } from "app/modules/admin/v2/operation/create/service/repurchase-payable.service";
import { GrowthBookService } from "app/shared/services/growthbook.service";
import * as amplitude from "@amplitude/analytics-browser";

@Component({
    selector: "app-create-operation",
    templateUrl: "./create-operation.component.html",
    styleUrls: ["./create-operation.component.scss"],
})
export class CreateOperationComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() progressValue = 0;
    @ViewChild("stepper") stepper: MatStepper;

    private FELIPE_OHANIAN_MINIBANK_ID = 143;
    private BANKME_AP_MINIBANK_ID = 465;
    private formBuilder: IFormBuilder;
    private unsubscribeAll = new Subject();
    private typePayableCreateAll = "DUPLICATA";
    private payableTypeSelected: PayableType;
    public hasConfirmedOffRisk = false;
    public rediscountTypeId = "10";
    public totalSteps: number;
    public currentStep = 0;
    public isRediscountOperation = false;

    public basicInfoForm: IFormGroup<BasicInformation>;
    public feesForm: IFormGroup<FeesForm>;
    public fundingForm: IFormGroup<FundingForm>;
    public paymentForm: IFormGroup<PaymentForm>;

    public disableFeesEditing: boolean;
    public filteredAssignors$: Observable<Cedente[]>;
    public filteredOperationModes$: Observable<OperacaoMode[]>;
    public shouldAnalyzePayerCredit = false;
    public shouldCheckPayable = false;
    public minibankPredefinedFees?: IMinibankFees;
    public files: File[] = [];
    public assignors: Cedente[];
    public operationModes: OperacaoMode[];
    public isLoading = false;
    public payables: Partial<Payable>[] = [];
    public statusSigla: OperationStatusEnum;
    public payablesIds: number[] = [];
    public quantitySteps = 6;
    public totalPercentageSteps = 100;
    public payablesAmount = 0;
    public operationTypes: IOperationTypes[];
    public bankServicesValueTooltip = messages.TOOLTIP_BANK_SERVICES_VALUE;
    public bankServiceTypes = BANK_SERVICE_TYPES;
    public bankServiceTypeSelected: string;
    public assignorName = "";
    public minibankName = "";
    public payableTypeList = PAYABLE_TYPE_LIST;
    public disablePayableType: boolean = false;
    public enableCreatePayableAll: boolean = false;
    public isSummaryExpanded = true;
    public inconsistencies: IOutputPayableError;
    public maxFileSize = MAX_FILE_SIZE;
    public isNextStepDisabled = false;
    public fundingData = {
        limit: 0,
        rate: 0,
        id: null,
    };
    public accountBalance: number | null = null;
    public operationData: OperationData = {
        amount: 0,
        dueDate: null,
        interestRate: 0,
        deduction: 0,
        netDeduction: 0,
        expenses: 0,
        totalDisbursement: 0,
        fundingDisbursement: 0,
        minibankDisbursement: 0,
        profitability: 0,
        hasFunding: false,
        totalRepurchase: 0,
        rawDisbursement: 0,
    };
    public totalDisbursement: number;
    public oldFundingFormState: FundingForm;

    public hasConfirmedFundingTerms = false;
    public termsData: TermsData = {
        acceptedAt: "",
        userIp: "",
        userAgent: "",
    };

    public paymentCards: ReceipientBankAccount[] = [];
    public bankType: string = "";
    public selectedPayableType = false;
    protected hasCheckCustody: boolean = false;
    protected shouldEmitPaymentSlip: boolean = true;
    public emitPaymentSlip: IFormGroup<{ hasEmit: string }>;

    public payablesSum: IPayable[] = [];
    public payablesToAnalyze: number[] = [];
    public allPayersSelected = false;
    public isOperationValid: boolean = true;
    public repurchasePayables: Partial<Payable>[] = [];
    public allUnoperatedPayablesResponse: UnoperatedPayablesResponse;
    public selectionUnoperatedPayables: UnoperatedPayablesSelection = {} as UnoperatedPayablesSelection;
    public selectedUnoperatedPayables = [];

    public showUnoperatedPayables = false;
    public totalRepurchase: number = 0;
    isShow: boolean = false;
    public showEmit = true;
    public isHighPerformance: boolean;
    public hasFilesAttached = false;
    public showFileError = false;
    public showRiscoZeroBanner = false;
    public bannerType: "risco-zero" | "default" | "intercompany" | null = null;

    constructor(
        private readonly cedenteService: ClientesService,
        private readonly operationService: OperacoesService,
        private readonly createOperationService: CreateOperationService,
        private readonly uploadModalService: UploadModalService,
        private readonly envioNotasModalService: EnvioNotasModalService,
        private readonly payableListService: PayableListService,
        private readonly userService: UserService,
        private readonly operationSummaryService: OperationSummaryService,
        private readonly authService: AuthService,
        private readonly fileValidator: FileValidator,
        private readonly repurchasePayableService: RepurchasePayableService,
        private readonly growthBookService: GrowthBookService,
        private snackBar: MatSnackBar,
        private router: Router,
        public dialog: MatDialog,
        public _formBuilder: FormBuilder,
        private readonly calculatorService: CalculoService,
    ) {
        this.formBuilder = _formBuilder;
    }

    async ngOnInit() {
        this.minibankName = this.userService.user$.minibanco?.razaoSocial;
        this.bankType = this.userService.user$.minibanco?.tipoNome ?? "";
        if (!this.bankType) {
            this.bankType = this.userService.user$.minibanco?.erpLabelId ? "ALTA PERFORMANCE" : "STANDARD";
            this.userService.user$.minibanco = { ...this.userService.user$.minibanco, tipoNome: this.bankType };
        }

        this.initForms();
        this.watchAssignorAutocomplete();
        this.filterOperationMode();
        this.getOperationTypes();

        this.bankServiceTypeChange(FeesEnum.INVOICES);

        this.payableListService.mustUpdateDisbursement.pipe(takeUntil(this.unsubscribeAll)).subscribe(() => {
            this.calculateDisbursement();
        });

        this.payableListService.currentPayableState.pipe(takeUntil(this.unsubscribeAll)).subscribe((payables) => {
            this.payables = payables;
        });

        if (this.userService.user$.minibanco.id === this.FELIPE_OHANIAN_MINIBANK_ID) {
            this.payableTypeList = [
                ...this.payableTypeList,
                {
                    label: "Nota comercial",
                    value: "DUPLICATA",
                },
            ];
        }

        if (this.userService.user$.minibanco?.id === this.BANKME_AP_MINIBANK_ID) {
            this.paymentForm.get("paymentType").setValue("PIX");

            this.paymentForm.get("paymentType").valueChanges.subscribe((value) => {
                if (value === "TED") {
                    setTimeout(() => {
                        this.paymentForm.get("paymentType").setValue("PIX");
                        this.snackBar.open(messages.ALERT_PAYMENT_TYPE_PIX_LOCKED, "X", {
                            duration: 5000,
                            panelClass: ["snackbar-warning"],
                        });
                    });
                }
            });
        }

        this.basicInfoForm.valueChanges.subscribe((value) => {
            if (value.typeOperation === this.rediscountTypeId) {
                this.isRediscountOperation = true;
                this.payableTypeList = this.payableTypeList.filter((payable) => payable?.value !== "NOTA_PROMISSORIA");
            }
            // Verificar o tipo da operação para exibir o banner
            if (value.typeOperation) {
                this.checkOperationTypeForBanner(value.typeOperation);
            } else {
                this.showRiscoZeroBanner = false;
                this.bannerType = null;
            }
        });

        this.envioNotasModalService.getPayables$.subscribe((payables) => {
            if (!payables.length) {
                this.payablesSum = [];
                this.payablesAmount = 0;
                this.operationSummaryService.updateCurrentPayables([]);
                return;
            }

            this.payables = payables;
            this.payablesSum = payables.reduce((acc, entry) => {
                const payerId = entry.sacado.id;
                const existingEntry = acc.find((e) => e.sacado.id === payerId);
                existingEntry ? (existingEntry.valor += entry.valor) : acc.push({ ...entry });
                return acc;
            }, []);

            this.payablesAmount = payables.reduce((acc, curr) => Number(acc) + Number(curr.valor), 0);
            this.operationSummaryService.updateCurrentPayables(this.payables);
            this.operationSummaryService.updateCurrentAmount(this.payablesAmount);

            const latestDueDate = this.payables.reduce((last, current) => {
                const lastDate = parse(last.dtVencimento as string, "dd/MM/yyyy", new Date());
                const currentDate = parse(current.dtVencimento as string, "dd/MM/yyyy", new Date());
                return compareAsc(lastDate, currentDate) === 1 ? last : current;
            });

            this.operationData = {
                ...this.operationData,
                amount: this.payablesAmount,
                dueDate: parse(latestDueDate.dtVencimento as string, "dd/MM/yyyy", new Date()),
            };

            this.setInitialDisbursementValues();
        });

        this.accountBalance = await this.createOperationService.getAccountBalance(this.userService.user$.minibanco?.id);
        const fundingData = await this.createOperationService.getFundingAmount();

        if (fundingData?.amount) {
            const accountBalance = this.normalizeAccountBalanceForFunding();
            this.fundingData = {
                limit: fundingData.amount,
                rate: fundingData.fundingInterestRate,
                id: fundingData.fundingId,
            };

            this.operationData = {
                ...this.operationData,
                hasFunding: true,
            };
            this.fundingForm.get("accountBalance").setValidators(Validators.max(accountBalance));
            this.fundingForm.get("fundingUsed").setValidators(Validators.max(fundingData.amount));
        }

        this.operationSummaryService.totalRepurchaseState.subscribe((totalRepurchase) => {
            this.operationData.totalRepurchase = totalRepurchase;
        });

        this.isHighPerformance = this.checkOperationForHighPerformance(this.userService.user$.minibanco);
    }

    checkOperationForHighPerformance(data): boolean {
        const typeName = String(data?.tipoNome || "");
        const isByTypeName = typeName.toLowerCase().includes("alta performance");
        const isByErpLabelId = !!data?.erpLabelId;

        return isByTypeName || isByErpLabelId;
    }

    async setInitialDisbursementValues() {
        const hasSelectedPayables = this.operationData.amount > 0;

        await this.calculateDisbursement();

        if (hasSelectedPayables) {
            this.calculateFundingDisbursement();
        }
    }

    calculateFundingDisbursement() {
        const accountBalance = this.normalizeAccountBalanceForFunding();
        const moneyLeft = this.operationData.totalDisbursement - accountBalance;
        const disbursement = this.operationData.totalDisbursement;

        if (moneyLeft > 0) {
            const accountBalanceRate = accountBalance / disbursement;
            this.fundingForm.patchValue(
                {
                    accountBalance: accountBalance,
                    fundingUsed: moneyLeft,
                    accountBalanceRate: accountBalanceRate * 100,
                    fundingRate: (1 - accountBalanceRate) * 100,
                },
                { emitEvent: true },
            );

            return;
        }

        this.fundingForm.patchValue(
            {
                accountBalance: disbursement,
                accountBalanceRate: 100,
                fundingUsed: 0,
                fundingRate: 0,
            },
            { emitEvent: true },
        );
    }

    public onStepChange() {
        this.updateProgress();
    }

    public previousProgressValue() {
        if (this.currentStep === 0) {
            return window.history.back();
        }

        this.currentStep -= 1;
        this.stepper.previous();
    }

    public isStarter(): boolean {
        return this.authService.isStarter;
    }

    public taxesForStarter(): void {
        if (this.isStarter && this.feesForm) {
            this.feesForm.get("feePerMonth").setValue(0);
        }
    }

    public skipStepForStarter(): boolean {
        return this.isStarter();
    }

    public isLastStep(): boolean {
        if (!this.stepper) return false;

        return this.stepper.selectedIndex === this.stepper.steps.length - 1;
    }

    private maxPercentageValidator(control: FormControl): { [key: string]: { value: number } } | null {
        const { value } = control;

        if (typeof value === "number") {
            if (value > 100) {
                return { maxPercentage: { value: value } };
            }

            return null;
        }
    }

    initForms() {
        this.basicInfoForm = this.formBuilder.group<BasicInformation>({
            assignor: [null, Validators.required],
            mode: [null, Validators.required],
            typeOperation: [null, Validators.required],
        });

        this.feesForm = this.formBuilder.group<FeesForm>({
            feePerMonth: [
                { value: 0, disabled: this.disableFeesEditing },
                [Validators.required, this.maxPercentageValidator, Validators.min(0.01), Validators.max(100.0)],
            ],
            tac: [{ value: 0, disabled: this.disableFeesEditing }, Validators.min(0)],
            ted: [{ value: 0, disabled: this.disableFeesEditing }, Validators.min(0)],
            digitalSignatureCost: [{ value: 0, disabled: this.disableFeesEditing }, Validators.min(0)],
            creditAnalysis: [{ value: 0, disabled: this.disableFeesEditing }, Validators.min(0)],
            pix: [{ value: 0, disabled: this.disableFeesEditing }, Validators.min(0)],
            bankServiceType: [FeesEnum.INVOICES],
            invoices: [{ value: 0, disabled: this.disableFeesEditing }, Validators.min(0)],
            checkCustody: [{ value: 0, disabled: this.disableFeesEditing }, Validators.min(0)],
            description: null,
            payableType: [null, Validators.required],
        });

        this.fundingForm = this.formBuilder.group<FundingForm>({
            accountBalance: [{ value: null, disabled: true }, Validators.required],
            accountBalanceRate: [null, [Validators.required, Validators.max(100), Validators.min(0)]],
            fundingUsed: [null, [Validators.required, Validators.min(0)]],
            fundingRate: [null, [Validators.required, Validators.max(100), Validators.min(0)]],
        });

        this.paymentForm = this.formBuilder.group<PaymentForm>({
            paymentType: [this.bankType !== "STANDARD" ? "PIX" : null, Validators.required],
            recipientId: [null, Validators.required],
        });

        this.emitPaymentSlip = this.formBuilder.group<{ hasEmit: string }>({
            hasEmit: ["true"],
        });

        this.emitPaymentSlip.controls.hasEmit.valueChanges.subscribe((value) => {
            const isCommission = String(this.basicInfoForm?.controls?.typeOperation?.value) === "4";
            const hasEmit = value === "true";

            if (isCommission) {
                this.shouldEmitPaymentSlip = false;
                this.showEmit = false;
                this.emitPaymentSlip.controls.hasEmit.setValue("false", { emitEvent: false });
                return;
            }

            this.shouldEmitPaymentSlip = this.feesForm.controls.payableType.value !== PayableType.CHEQUE && hasEmit;
            this.hasCheckCustody = this.feesForm.controls.payableType.value === PayableType.CHEQUE && hasEmit;
            if (!this.shouldEmitPaymentSlip && this.feesForm.controls.payableType.value !== PayableType.CHEQUE) {
                this.openDialogAskWithoutPaymentSlip();
            }
        });

        this.basicInfoForm.controls.assignor.valueChanges.subscribe(() => {
            const assignor = this.basicInfoForm.get("assignor").value;
            this.assignorName = assignor ? assignor.razaoSocial || assignor.nomeFantasia : "";
            this.operationSummaryService.updateAssignor(this.assignorName);

            if (!assignor || !this.assignorName) return;

            this.repurchasePayableService.setAssignorId = assignor.id;
            this.repurchasePayableService
                .listUnoperatedPayables(this.basicInfoForm.get("assignor").value.id, {
                    page: 1,
                    take: 10,
                })
                .then((res: UnoperatedPayablesResponse) => {
                    this.allUnoperatedPayablesResponse = res;
                    this.showUnoperatedPayables = res.data.length > 0;
                    this.repurchasePayableService.setUnoperatedPayables = res;
                });

            this.createOperationService
                .getAssignorBankAccounts(assignor.id)
                .then((response: ReceipientBankAccount[]) => {
                    this.paymentCards = response
                        .filter((card) => !card.deletedAt)
                        .map((card) => {
                            return {
                                ...card,
                                accountHolder: card.accountHolder || this.assignorName,
                                document: card.document || assignor.cnpj,
                            };
                        });
                });
        });
        this.operationSummaryService.updateMinibank(this.userService.user$.minibanco?.razaoSocial);

        this.feesForm.controls.feePerMonth.valueChanges.subscribe((value) => {
            this.operationSummaryService.updateTaxRate(String(value));
        });

        this.feesForm.valueChanges.pipe(debounceTime(500)).subscribe(() => {
            const expense = this.getTotalExpenses();

            this.operationSummaryService.updateExpense(expense);

            this.setInitialDisbursementValues();

            this.operationSummaryService.currentOperationSummaryState;

            this.operationData = {
                ...this.operationData,
                expenses: expense,
                interestRate: Number(String(this.feesForm.controls.feePerMonth.value)) / 100,
            };
        });

        this.fundingForm.controls.accountBalance.valueChanges.subscribe((value) => {
            this.operationData = {
                ...this.operationData,
                minibankDisbursement: value,
            };
        });

        this.fundingForm.valueChanges.subscribe((value) => {
            this.isNextStepDisabled = false;
            const { accountBalanceRate, fundingRate, fundingUsed } = value;

            const isAccountBalanceRateChanged = this.oldFundingFormState?.accountBalanceRate !== accountBalanceRate;
            const isFundingRateChanged = this.oldFundingFormState?.fundingRate !== fundingRate;
            const isFundingUsedChanged = this.oldFundingFormState?.fundingUsed !== fundingUsed;
            const totalDisbursement = this.operationData.totalDisbursement;

            this.oldFundingFormState = value;

            if (!isAccountBalanceRateChanged && !isFundingRateChanged && !isFundingUsedChanged) {
                return;
            }

            if (isAccountBalanceRateChanged) {
                const minibankDisbursement = (totalDisbursement * accountBalanceRate) / 100;
                const fundingDisbursement = (totalDisbursement * (100 - accountBalanceRate)) / 100;

                this.fundingForm.patchValue(
                    {
                        fundingRate: 100 - accountBalanceRate,
                        fundingUsed: fundingDisbursement,
                        accountBalance: minibankDisbursement,
                    },
                    { emitEvent: true },
                );

                this.operationData = {
                    ...this.operationData,
                    minibankDisbursement,
                    fundingDisbursement,
                };
            }

            if (isFundingRateChanged) {
                const minibankDisbursement = (totalDisbursement * (100 - fundingRate)) / 100;
                const fundingDisbursement = (totalDisbursement * fundingRate) / 100;

                this.fundingForm.patchValue(
                    {
                        accountBalanceRate: 100 - fundingRate,
                        accountBalance: minibankDisbursement,
                        fundingUsed: fundingDisbursement,
                    },
                    { emitEvent: true },
                );

                this.operationData = {
                    ...this.operationData,
                    fundingDisbursement,
                    minibankDisbursement,
                };
            }

            if (isFundingUsedChanged) {
                const split = splitDisbursementByFundingUsed(totalDisbursement, value.fundingUsed);

                this.fundingForm.patchValue(buildFundingUsedChangePatch(totalDisbursement, value.fundingUsed), {
                    emitEvent: true,
                });

                this.operationData = {
                    ...this.operationData,
                    fundingDisbursement: split.fundingUsed,
                    minibankDisbursement: split.accountBalance,
                };
            }

            if (this.operationData.hasFunding && this.fundingForm.invalid && this.stepper.selectedIndex === 2) {
                this.isNextStepDisabled = true;
                return;
            }

            this.calculateDisbursement();
        });
    }

    private normalizeAccountBalanceForFunding(): number {
        if (this.accountBalance == null) {
            return 0;
        }
        return this.accountBalance < 0 ? 0 : this.accountBalance;
    }

    private validateFundingForm() {
        if (!this.operationData.hasFunding) {
            this.isNextStepDisabled = false;
            return;
        }

        const fundingLimit = Number(this.fundingData.limit || 0);
        const totalDisbursement = this.operationData.totalDisbursement;
        const accountBalance = this.normalizeAccountBalanceForFunding();
        const insufficientFunds = totalDisbursement > accountBalance + fundingLimit;
        const negativeProfitability = this.operationData.profitability < 0;
        const fundingMoreThanLimit = this.fundingForm.get("fundingUsed").value > fundingLimit;
        const moreThan100Percent =
            this.fundingForm.get("accountBalanceRate").value > 100 || this.fundingForm.get("fundingRate").value > 100;

        if (
            (insufficientFunds || negativeProfitability || fundingMoreThanLimit || moreThan100Percent) &&
            this.stepper.selectedIndex === 2
        ) {
            this.isNextStepDisabled = true;
            return;
        }
        this.isNextStepDisabled = false;
    }

    private isFundingUsedValid() {
        if (!this.operationData.hasFunding) {
            return true;
        }

        const accountBalance = this.normalizeAccountBalanceForFunding();
        const balanceUsed = this.fundingForm.get("accountBalance").value || 0;
        const fundingUsed = this.fundingForm.get("fundingUsed").value || 0;

        if (balanceUsed > accountBalance && fundingUsed > 0) {
            return false;
        }

        return true;
    }

    confirmOffRisk() {
        this.hasConfirmedOffRisk = true;
        this.shouldAnalyzePayerCredit = false;
        this.shouldCheckPayable = false;
        this.allPayersSelected = false;
        this.payablesToAnalyze = [];

        this.nextProgressValue();
    }

    getTotalExpenses() {
        return (
            this.feesForm.get("tac").value +
            this.feesForm.get("ted").value +
            this.feesForm.get("invoices").value +
            this.feesForm.get("creditAnalysis").value +
            this.feesForm.get("pix").value +
            this.feesForm.get("digitalSignatureCost").value +
            this.feesForm.get("checkCustody").value
        );
    }

    cleanValidator({ field }: { field: FeesEnum }) {
        this.feesForm.controls[field].setValue(0);
    }

    bankServiceTypeChange(serviceType: string) {
        this.bankServiceTypeSelected = serviceType;

        const feeTypeTest = {
            invoices: () => this.cleanValidator({ field: FeesEnum.CHECK_CUSTODY }),
            checkCustody: () => this.cleanValidator({ field: FeesEnum.INVOICES }),
        };

        serviceType && feeTypeTest[serviceType as keyof typeof feeTypeTest]();
    }

    public async getOperationTypesAvailable() {
        const operationTypes = await this.createOperationService.getOperationTypes();

        if (this.authService.isStarter) {
            return operationTypes.filter((operationType) => operationType.attributes.description === "REDESCONTO");
        }

        return operationTypes.filter(
            (operationType) =>
                operationType.attributes.description !== "REDESCONTO" &&
                operationType.attributes.description !== "EXPRESS",
        );
    }

    public async getOperationTypes() {
        this.operationTypes = await this.getOperationTypesAvailable();
    }

    onSelect(event: NgxDropzoneChangeEvent) {
        if (!this.fileValidator.validateEvent(event)) return;
        this.files.push(...event.addedFiles);
        this.hasFilesAttached = this.files.length > 0;
        this.showFileError = false;
    }

    onRemove(event: File) {
        this.files.splice(this.files.indexOf(event), 1);
        this.hasFilesAttached = this.files.length > 0;
        this.showFileError = false;
    }

    public async filterOperationMode(): Promise<void> {
        const operationModes = await this.operationService.getOperationModes().toPromise();
        const rediscountOperationId = 34;

        const filteredOperationModes = operationModes.filter(
            (operationMode) => operationMode.id !== rediscountOperationId,
        );

        if (this.authService.isStarter) {
            const riskSecOperationId = 22;
            const operationModesForStarter = filteredOperationModes.filter(
                (operationMode) => operationMode.id === riskSecOperationId,
            );

            this.filteredOperationModes$ = of(operationModesForStarter);
            return;
        }

        this.filteredOperationModes$ = of(filteredOperationModes);
    }

    watchAssignorAutocomplete() {
        this.cedenteService
            .listaCedentes()
            .toPromise()
            .then((result) => {
                if (result) {
                    this.assignors = result.data;
                    this.filteredAssignors$ = of(result.data);
                }
            });

        this.basicInfoForm
            .get("assignor")
            .valueChanges.pipe(debounceTime(500))
            // eslint-disable-next-line @typescript-eslint/no-misused-promises, rxjs/no-async-subscribe
            .subscribe(async (value) => {
                const response: Cedente[] = await this.findAssignors(value as string);
                this.filteredAssignors$ = of(response);
            });
    }

    async findAssignors(assignor: string): Promise<Cedente[]> {
        return this.cedenteService.filterAssignors(assignor);
    }

    openChooseUploadFileModal() {
        if (this.basicInfoForm.get("assignor").invalid) {
            return this.snackBar.open(messages.ALERT_FILL_ASSIGNOR_FIELD, "X", { duration: 5000 });
        }

        const dialog = this.dialog.open(ChooseUploadFileModalComponent, {
            data: {
                payableType: this.payableTypeSelected,
            },
        });

        dialog.componentInstance.xmlEmitter.subscribe(() => {
            dialog.close();
            this.openSendPayablesModal(FileType.XML);
        });

        dialog.componentInstance.spreadsheetEmitter.subscribe(() => {
            dialog.close();
            this.openSendPayablesModal(FileType.XLSX);
        });

        dialog.componentInstance.imgEmitter.subscribe(() => {
            dialog.close();
            this.openCheckPayableModal();
        });

        dialog.componentInstance.closeEmitter.subscribe(() => {
            dialog.close();
        });
    }

    openCheckPayableModal() {
        this.dialog.open(UploadBankCheckModalComponent, {
            width: "100%",
            data: {
                assignor: this.basicInfoForm.get("assignor").value,
                payableType: this.payableTypeSelected,
            },
        });
    }

    openSendPayablesModal(fileType: FileType) {
        const sendPayablesDialog = this.dialog.open(EnviarNotasModalComponent, {
            disableClose: false,
            width: "100%",
            data: {
                assignor: this.basicInfoForm.get("assignor").value,
                fileType: fileType,
            },
        });

        sendPayablesDialog.componentInstance.close.subscribe(() => {
            sendPayablesDialog.close();
        });

        sendPayablesDialog.componentInstance.inconsistenciesEmitter.subscribe(
            (inconsistencies: IOutputPayableError) => {
                this.inconsistencies = inconsistencies;
                sendPayablesDialog.close();
            },
        );
    }

    openSearchPayablesInDataBaseModal() {
        if (this.basicInfoForm.get("assignor").invalid) {
            return this.snackBar.open(messages.ALERT_FILL_ASSIGNOR_FIELD, "X", { duration: 5000 });
        }

        this.dialog.open(PayablesFromDatabaseModalComponent, {
            width: "100%",
            data: {
                assignor: this.basicInfoForm.get("assignor").value,
                payableType: this.payableTypeSelected,
            },
        });
    }

    openModalCreatePayables() {
        if (this.basicInfoForm.get("assignor").invalid) {
            return this.snackBar.open(messages.ALERT_FILL_ASSIGNOR_FIELD, "X", { duration: 5000 });
        }

        this.dialog.open(CreatePayablesModalComponent, {
            width: "100%",
            data: {
                assignor: this.basicInfoForm.get("assignor").value,
                payableType: this.payableTypeSelected,
            },
        });
    }

    displayCorporateName(value: Cedente): string {
        if (value !== null) return value.razaoSocial;
    }

    getMinibankDisbursementValue() {
        if (!this.operationData.hasFunding) {
            return this.operationData.totalDisbursement;
        }
        return this.operationData.totalDisbursement - (this.operationData.fundingDisbursement || 0);
    }

    async nextProgressValue() {
        const isCommission = String(this.basicInfoForm?.controls?.typeOperation?.value) === "4";
        if (isCommission) {
            this.showEmit = false;
            this.emitPaymentSlip.controls.hasEmit.setValue("false", { emitEvent: false });
            this.shouldEmitPaymentSlip = false;
        }
        const step = this.stepper.selectedIndex;

        this.payablesToAnalyze = this.payablesToAnalyze.filter((a) => a !== null && a !== undefined);

        const filteredPayablesToAnalyze = this.payablesToAnalyze.filter((a) => a !== null && a !== undefined);
        if (step === 1) {
            const enabledByType = this.basicInfoForm.controls.typeOperation.value === "4" ? "disable" : "enable";
            this.feesForm.get("invoices")[enabledByType]();
        }

        if (this.inconsistencies?.errors && step === 2) {
            this.snackBar.open(
                `${messages.ALERT_INCONSISTENCY_FOUND} ${this.inconsistencies?.errors?.details[0]?.fileFailures[0]}`,
                "X",
                { duration: 5000 },
            );
            return;
        }

        if (this.basicInfoForm.invalid && step === 0) {
            this.snackBar.open(messages.ALERT_ALL_FIELDS_REQUIRED, "X", { duration: 5000 });
            return;
        }

        if (
            (this.feesForm.controls.payableType.invalid && step === 1) ||
            (this.feesForm.controls.feePerMonth.value == 0 && step == 2)
        ) {
            this.snackBar.open(messages.ALERT_ALL_FIELDS_REQUIRED, "X", { duration: 5000 });
            return;
        }

        if (!this.payables.length && step === 2) {
            this.snackBar.open(messages.ALERT_OPERATION_SHOULD_CONTAIN_PAYABLE, "X", { duration: 5000 });
            return;
        }

        if (this.operationData.hasFunding && this.fundingForm.invalid && step === 2) {
            this.snackBar.open(messages.ALERT_INVALID_FUNDING, "X", { duration: 5000 });
            return;
        }

        if (step === 2 && this.operationData.totalRepurchase > 0 && this.operationData.totalDisbursement < 0) {
            this.isOperationValid = false;
            this.snackBar.open(messages.ALERT_OPERATION_MUST_CONTAIN_PAYABLE, "X", {
                duration: 5000,
            });

            return;
        }

        if (!this.hasConfirmedOffRisk && !this.shouldCheckPayable && !this.shouldAnalyzePayerCredit && step === 3) {
            this.snackBar.open(messages.ALERT_SELECT_AT_LEAST_ONE_CHECKBOX, "X", { duration: 5000 });
            return;
        }

        if (this.shouldAnalyzePayerCredit && filteredPayablesToAnalyze.length === 0 && step === 3) {
            this.snackBar.open("Selecione ao menos um sacado para consulta de crédito.", "X", {
                duration: 5000,
            });
            return;
        }

        if (this.paymentForm.invalid && step === 4) {
            this.snackBar.open(messages.ALERT_SOME_FIELDS_REQUIRED, "X", {
                duration: 5000,
            });
            return;
        }

        if (
            this.payables.some((payable) =>
                [null, "Invalid date"].includes(payable.dtVencimento as unknown as string),
            ) &&
            step === 3
        ) {
            this.snackBar.open(messages.ALERT_PAYABLES_MUST_HAVE_DUE_DATE, "X", { duration: 5000 });
            return;
        }

        if (this.feesForm.invalid && [3, 4].includes(step)) {
            this.snackBar.open(messages.ALERT_ALL_FIELDS_REQUIRED, "X", { duration: 5000 });
            return;
        }

        if (step === 2 && this.totalDisbursement < 0) {
            this.snackBar.open(messages.ALERT_DISBURSEMENT_LESS_THAN_ZERO, "X", { duration: 5000 });
            return;
        }

        if (step === 2) {
            const isCommission = String(this.basicInfoForm?.controls?.typeOperation?.value) === "4";
            if (isCommission) {
                this.showEmit = false;
                this.emitPaymentSlip.controls.hasEmit.setValue("false", { emitEvent: false });
                this.shouldEmitPaymentSlip = false;
                this.currentStep += 1;
                this.stepper.next();
                return;
            }
            this.isLoading = true;

            try {
                await this.calculateDisbursement();
                await new Promise((resolve) => setTimeout(resolve, 500));
            } catch {
                this.snackBar.open(messages.ALERT_DISBURSEMENT_CALCULATION_ERROR, "X", { duration: 5000 });
                return;
            } finally {
                this.isLoading = false;
            }

            if (!this.isFundingUsedValid()) {
                this.snackBar.open(messages.ALERT_INVALID_FUNDING, "X", { duration: 5000 });
                return;
            }

            this.currentStep += 1;
            this.stepper.next();
        } else {
            this.currentStep += 1;
            this.stepper.next();
        }
    }

    public updateProgress() {
        if (this.stepper && this.stepper.selectedIndex >= 0) {
            this.progressValue = (this.currentStep / (this.totalSteps - 1)) * 100;
        } else {
            this.progressValue = 0;
        }
    }

    public initStepper() {
        if (this.stepper) {
            this.totalSteps = this.stepper.steps.length;
            this.updateProgress();
        }
    }

    public viewInit(): void {
        this.taxesForStarter();
        this.initStepper();
    }

    ngAfterViewInit() {
        this.viewInit();
    }

    async saveRecebiveisCreated() {
        if (this.isLoading) return;
        this.isLoading = true;

        if (this.userService.user$.minibanco.id === this.BANKME_AP_MINIBANK_ID && this.files.length === 0) {
            this.showFileError = true;
            this.snackBar.open(messages.ALERT_MISSING_FILES_TO_COMPLETE_OPERATION, "X", {
                duration: 5000,
                panelClass: ["snackbar-error"],
            });
            this.isLoading = false;
            return;
        }

        this.showFileError = false;

        if (this.shouldAnalyzePayerCredit && this.payablesToAnalyze.length === 0) {
            this.snackBar.open("Selecione ao menos um sacado para consulta de crédito.", "X", {
                duration: 5000,
            });
            this.isLoading = false;
            return;
        }

        if (this.basicInfoForm.invalid) {
            this.snackBar.open(messages.ALERT_SOME_FIELDS_REQUIRED, "X", {
                duration: 5000,
            });
            this.isLoading = false;
            return;
        }

        if (!this.payables.length) {
            this.snackBar.open(messages.ALERT_OPERATION_SHOULD_CONTAIN_PAYABLE, "X", {
                duration: 5000,
            });
            this.isLoading = false;
            return;
        }

        if (this.paymentForm.invalid) {
            this.snackBar.open(messages.ALERT_SOME_FIELDS_REQUIRED, "X", {
                duration: 5000,
            });
            this.isLoading = false;
            return;
        }

        if (this.operationData.hasFunding && this.operationData.fundingDisbursement && !this.hasConfirmedFundingTerms) {
            this.snackBar.open(messages.ALERT_ACCEPT_TERMS, "X", { duration: 5000 });
            this.isLoading = false;
            return;
        }

        if (this.files.length === 0 && this.isHighPerformance) {
            this.snackBar.open(messages.ALERT_OPERATION_WITHOUT_FILES, "X");
            this.isLoading = false;
            return;
        }

        const { feePerMonth, description } = this.feesForm.controls;
        const { mode } = this.basicInfoForm.controls;

        if (this.shouldAnalyzePayerCredit || this.shouldCheckPayable) {
            this.addCreditAnalysisNote();
        }
        this.statusSigla = OperationStatusEnum.NEW_OPERATION;

        this.envioNotasModalService.getPayables$.subscribe((payable) => {
            this.payablesIds = payable?.map((payable) => payable?.id);
        });

        const { tac, ted, invoices, creditAnalysis, pix, checkCustody, digitalSignatureCost, payableType } =
            this.feesForm.value;

        const { paymentType, recipientId } = this.paymentForm.value;

        const { hasEmit } = this.emitPaymentSlip.value;

        const isCommission = String(this.basicInfoForm?.controls?.typeOperation?.value) === "4";
        const hasCheck = this.feesForm.controls.payableType.value === PayableType.CHEQUE;

        const shouldEmitPaymentSlip = this.isHighPerformance ? !(isCommission || hasCheck) : this.shouldEmitPaymentSlip;

        const createOperationObject: Partial<Operacao> = {
            taxa: this.convertTax(String(feePerMonth.value)) / 100,
            descricao: description.value ? description.value : null,
            statusSigla: this.statusSigla,
            payablesIds: this.payablesIds,
            typeId: Number(this.basicInfoForm.get("typeOperation").value),
            modalidadeId: mode.value,
            minibancoId: this.userService.user$?.minibanco.id,
            salesmanId: 1,
            keyAccountId: 1,
            payableType: PayableType[payableType],
            fees: {
                tac,
                ted,
                invoices: invoices ?? 0,
                creditAnalysis,
                pix,
                checkCustody,
                digitalSignatureCost,
            },
            shouldCheckPayable: this.shouldCheckPayable,
            shouldAnalyzePayerCredit: this.shouldAnalyzePayerCredit,
            termsData: this.termsData,
            ...(this.operationData.hasFunding &&
                this.fundingForm.get("fundingUsed").value > 0 && {
                    fundingId: this.fundingData.id,
                    fundingAmount: Math.round(this.fundingForm.get("fundingUsed").value * 100) / 100,
                }),
            assignorBankDataId: Number(recipientId),
            paymentType,
            cedenteId: this.basicInfoForm.get("assignor").value.id,
            hasCheckCustody: this.hasCheckCustody && hasEmit === "true",
            shouldEmitPaymentSlip,
            payersToAnalyze: this.payablesToAnalyze,
            disbursement: this.operationData.rawDisbursement,
            hasRepurchasedPayables: this.selectedUnoperatedPayables.length > 0,
        };
        console.log({
            createOperationObject,
        });

        try {
            const operation = await this.operationService.createOperacao(createOperationObject).toPromise();

            if (this.files.length > 0) {
                await this.uploadOperacaoFiles(operation.id);
            }

            if (this.selectedUnoperatedPayables.length > 0) {
                await this.createOperationService.createRepurchasedPayables({
                    operationId: operation.id,
                    disbursement: this.operationData.totalDisbursement,
                    ...this.selectionUnoperatedPayables,
                });
            }

            this.onSuccessPostOperacao(operation.id, messages.SUCCESS_OPERATATION_CREATED);

            amplitude.track(`${environment.environment}_op_custom_completed`, {
                operationType: operation.type,
                minibanco_id: this.userService.user$?.minibanco.id,
                minibanco_name: this.userService.user$?.minibanco.nomeFantasia,
                minibanco_document: this.userService.user$?.minibanco.cnpj,
                role: this.userService.user$?.roles[0],
            });

            this.isLoading = false;
        } catch (error) {
            this.snackBar.open(`Erro ao criar operação:  ${JSON.stringify(error)}`, "x", {
                duration: 5000,
                panelClass: "snack-bar-error",
            });

            amplitude.track(`${environment.environment}_op_custom_error`, {
                minibanco_id: this.userService.user$?.minibanco.id,
                minibanco_name: this.userService.user$?.minibanco.nomeFantasia,
                minibanco_document: this.userService.user$?.minibanco.cnpj,
                role: this.userService.user$?.roles[0],
                error: "Erro ao solicitar operação",
            });

            console.error("Erro ao criar operação", error);
            this.isLoading = false;
        }
    }

    addCreditAnalysisNote() {
        this.shouldAnalyzePayerCredit &&
            this.shouldCheckPayable &&
            this.feesForm.get("description").setValue("Solicitado checagem");
    }

    convertTax(taxa: string): number {
        return Number(taxa?.replace(",", "."));
    }

    onSuccessPostOperacao(operationId: number, snackBarText: string) {
        this.snackBar
            .open(snackBarText, "Ver Operação", {
                duration: 3500,
            })
            .onAction()
            .subscribe(() => {
                if (environment.environment === "demo") {
                    this.router.navigateByUrl("/operacoes");
                    return;
                }

                window.location.href = `${environment.vars.next}/operations/${operationId}`;
            });

        if (environment.environment === "demo") {
            this.router.navigateByUrl("/operacoes");
            return;
        }

        window.location.href = `${environment.vars.next}/operations/${operationId}`;
    }

    async uploadOperacaoFiles(operationId: number, description?: string) {
        return await this.uploadModalService.uploadFileAsync(this.files, operationId, "operacao", description);
    }

    async updateOperationMode($event: MatSelectChange) {
        const foundMode = await this.findMode($event.value);
        if (foundMode) {
            const description = foundMode.descricao;
            this.operationSummaryService.updateRisk(description);
        }
        // O banner é controlado pelo tipo da operação, não pela modalidade
    }

    /**
     * Verifica o tipo da operação para determinar se deve exibir o banner
     * O banner só aparece para: risco-zero, default ou intercompany
     */
    checkOperationTypeForBanner(typeOperationId: string | number) {
        const isExpressEnabled = this.growthBookService.isFeatureEnabled(
            featureFlags.ENABLE_STANDARD_EXPRESS_OPERATIONS,
        );

        if (!isExpressEnabled) {
            this.showRiscoZeroBanner = false;
            this.bannerType = null;
            return;
        }
        const selectedType = this.operationTypes?.find((type) => String(type.id) === String(typeOperationId));

        if (!selectedType) {
            this.showRiscoZeroBanner = false;
            this.bannerType = null;
            return;
        }

        const descriptionLower = selectedType.attributes?.description?.toLowerCase() || "";
        const acronymLower = selectedType.attributes?.acronym?.toLowerCase() || "";

        // Verificar se é uma das 3 opções que devem exibir o banner
        if (
            descriptionLower.includes("risco zero") ||
            acronymLower.includes("risco-zero") ||
            acronymLower.includes("riscozero")
        ) {
            this.bannerType = "risco-zero";
            this.showRiscoZeroBanner = true;
        } else if (descriptionLower.includes("intercompany") || acronymLower.includes("intercompany")) {
            this.bannerType = "intercompany";
            this.showRiscoZeroBanner = true;
        } else if (descriptionLower.includes("default") || acronymLower.includes("default")) {
            this.bannerType = "default";
            this.showRiscoZeroBanner = true;
        } else {
            // Se não for nenhuma das 3 opções, não exibir o banner
            this.showRiscoZeroBanner = false;
            this.bannerType = null;
        }
    }

    onFollowConventional(): void {
        // Esconder o banner e continuar com o fluxo convencional
        this.showRiscoZeroBanner = false;
        this.bannerType = null;
    }

    onFollowExpress(): void {
        // Redirecionar para a página de criação de operação Express usando o host da environment
        const expressUrl = `${environment.vars.next}/operations/simulate`;
        window.location.href = expressUrl;
    }

    async findMode(id: number) {
        const modes = await this.filteredOperationModes$.toPromise();
        const foundMode = modes.find((mode) => mode.id === id);
        return foundMode;
    }

    ngOnDestroy(): void {
        this.envioNotasModalService.setPayables = [];
        this.operationSummaryService.updateCurrentPayables([]);
        this.payableListService.sendCurrentPayables([]);

        this.unsubscribeAll.next();
        this.unsubscribeAll.complete();
    }

    changePayableType($event: MatSelectChange) {
        this.dialog
            .open(ConfirmTypePayableModalComponent, {
                disableClose: true,
                width: "auto",
                data: {},
            })
            .afterClosed()
            .pipe(takeUntil(this.unsubscribeAll))
            .subscribe((result) => {
                if (result == "cancel") {
                    this.payableTypeSelected = null;
                    this.feesForm.controls.payableType.setValue(null);
                    this.selectedPayableType = false;
                    return;
                }

                this.disablePayableType = !this.disablePayableType;
                this.enableCreatePayableAll = $event.value === this.typePayableCreateAll;
                this.payableTypeSelected = $event.value;

                this.hasCheckCustody = $event.value === PayableType.CHEQUE;
                this.shouldEmitPaymentSlip = $event.value !== PayableType.CHEQUE;

                if (this.isHighPerformance) {
                    const isCommissioner = Number(this.basicInfoForm.controls.typeOperation.value) === 4;
                    const isBankSlip = $event.value !== PayableType.CHEQUE;

                    if (isBankSlip) {
                        if (isCommissioner) {
                            this.emitPaymentSlip.controls.hasEmit.setValue("false");
                            this.shouldEmitPaymentSlip = false;
                        } else {
                            this.emitPaymentSlip.controls.hasEmit.setValue("true");
                            this.shouldEmitPaymentSlip = true;
                        }
                    }
                }

                if (PayableType.CHEQUE === $event.value) {
                    this.bankServiceTypeChange(FeesEnum.CHECK_CUSTODY);
                    this.feesForm.controls.bankServiceType.setValue(FeesEnum.CHECK_CUSTODY);
                }

                this.selectedPayableType = true;
                if (
                    Number(this.basicInfoForm.controls.typeOperation.value) === 4 &&
                    $event.value !== PayableType.CHEQUE
                ) {
                    this.showEmit = false;
                    this.nextProgressValue();
                    return;
                }

                if ((this.bankType !== "STANDARD" || !this.showEmit) && PayableType.CHEQUE !== $event.value) {
                    this.nextProgressValue();
                }
            });
    }

    treatCase(label: string) {
        const CamelCase = label.charAt(0).toUpperCase() + label.slice(1).toLowerCase();
        return CamelCase.replaceAll("Ccb", "CCB");
    }

    async calculateDisbursement() {
        const isCheque = this.feesForm.controls.payableType.value === EnumTypeDocument.CHEQUE;
        const insertedValues = {
            typeDocument: isCheque ? EnumTypeDocument.CHEQUE : EnumTypeDocument.DUPLICATA,
            taxRate: Number(String(this.feesForm.controls.feePerMonth.value).replace("%", "").replaceAll(",", ".")),
            costOperation: this.getTotalExpenses(),
            installmentValues: this.payables.map((payable) => Number(payable?.valor)),
            dueDates: this.payables.map((dueDate) => {
                const dueDateFormatted = DATE_FORMAT_REGEX.test(dueDate.dtVencimento as string)
                    ? String(dueDate.dtVencimento).split("/").reverse().join("-")
                    : dueDate.dtVencimento;

                return adjustDateToEndOfDay(new Date(dueDateFormatted).toISOString());
            }),
            ...(this.operationData.hasFunding && {
                fundingInterestRate: this.fundingData.rate * 100,
                fundingAmount: this.fundingForm.get("fundingUsed").value || 0,
            }),
        };

        const { deductions, disbursement, fundingDeductions } = await this.calculatorService
            .calculateFunding(insertedValues)
            .toPromise();

        const deduction = deductions.reduce((acc, curr) => acc + curr, 0);
        const fundingDeduction = fundingDeductions?.reduce((acc, curr) => acc + curr, 0) || 0;

        const netDeduction = deduction - fundingDeduction;

        const rawDisbursement = disbursement;

        const totalRepurchase = this.selectionUnoperatedPayables?.repurchaseValue || 0;
        const finalDisbursement = disbursement - totalRepurchase;

        this.operationData = {
            ...this.operationData,
            deduction,
            netDeduction,
            totalDisbursement: finalDisbursement,
            totalRepurchase: totalRepurchase,
            rawDisbursement: rawDisbursement,
            profitability: calculateFundingProfitability(netDeduction, this.fundingForm.get("accountBalance").value),
        };

        this.totalDisbursement = rawDisbursement;

        this.validateFundingForm();
        this.calculateRepurchase();
    }

    calculateRepurchase(): void {
        const totalRepurchase = this.selectionUnoperatedPayables.repurchaseValue || 0;

        const totalDisbursement = this.totalDisbursement - totalRepurchase;

        this.isOperationValid = true;

        this.operationData = {
            ...this.operationData,
            totalRepurchase: totalRepurchase,
            totalDisbursement: totalDisbursement,
            rawDisbursement: this.totalDisbursement,
        };

        this.validateFundingForm();
    }

    async acceptedTerms(event: { checked: boolean }) {
        this.hasConfirmedFundingTerms = event.checked;

        const acceptedAt = new Date().toISOString();
        const response = await fetch("https://api.ipify.org?format=json");
        const data = await response.json();

        const userAgent = navigator.userAgent;

        this.termsData = {
            acceptedAt,
            userIp: data.ip,
            userAgent,
        };
    }

    openCreateBankAccountModal() {
        const bankAccountModal = this.dialog.open(BankAccountModalComponent, {
            data: this.basicInfoForm.get("assignor").value,
            width: "80%",
        });

        bankAccountModal.afterClosed().subscribe((result) => {
            if (result) {
                this.createOperationService
                    .getAssignorBankAccounts(this.basicInfoForm.get("assignor").value.id)
                    .then((data) => {
                        this.paymentCards = data;
                    });
            }
        });
    }

    selectCardBankAccount(card: ReceipientBankAccount) {
        if (!card.id) {
            this.paymentForm.get("recipientId").setValue(null);
            return;
        }
        this.paymentForm.get("recipientId").setValue(String(card.id));
    }

    openDialogAskWithoutPaymentSlip() {
        const askWithoutPaymentSlipModal = this.dialog.open(AskWithoutPaymentSlipModalComponent, {
            width: "800px",
            data: { payableType: this.feesForm.controls.payableType.value },
        });

        askWithoutPaymentSlipModal.afterClosed().subscribe((result) => {
            if (result === "cancel") {
                this.emitPaymentSlip.controls.hasEmit.setValue("true");
                return;
            }

            this.nextProgressValue();
        });
    }

    maskDocument(document: string) {
        if (document.length === 11) {
            return document.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
        }
        return document.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
    }

    addPayableToAnalyze(payable: Partial<Payable>) {
        if (this.payablesToAnalyze.includes(payable.sacado.id)) {
            this.payablesToAnalyze = this.payablesToAnalyze.filter((p) => p !== payable.sacado.id);
            this.allPayersSelected = this.payablesToAnalyze.length === this.payables.length;
            return;
        }
        this.payablesToAnalyze.push(payable.sacado.id);
        this.allPayersSelected = this.payablesToAnalyze.length === this.payables.length;
    }

    toggleAllPayersToAnalysis(event: Event) {
        const input = event.target as HTMLInputElement;
        this.allPayersSelected = input.checked;
        this.payablesToAnalyze = input.checked ? this.payables.map((payable) => payable.sacado.id) : [];
    }

    handleChecked(type: string, checked: boolean) {
        this[type] = checked;
    }

    openRepurchasePayables() {
        this.isShow = true;
    }

    async selectedRepurchasedPayables(event: UnoperatedPayablesSelection) {
        this.selectionUnoperatedPayables = event;
        this.selectedUnoperatedPayables = event.payables;

        this.totalRepurchase = event.repurchaseValue;

        this.calculateRepurchase();

        if (this.selectedUnoperatedPayables.length > 0) {
            const preview = await this.createOperationService.previewRepurchaseDisbursement({
                lateFeePercentage: event.lateFeePercentage,
                finePercentage: event.finePercentage,
                payables: event.payables,
                lateFeeAndFineSum: event.lateFeeAndFineSum,
                repurchaseValue: event.repurchaseValue,
                disbursement: this.operationData.rawDisbursement,
            });

            if (preview) {
                this.operationData = {
                    ...this.operationData,
                    totalRepurchase: preview.repurchaseValue,
                    totalDisbursement: preview.netDisbursement,
                };
            }
        }

        if (this.operationData.hasFunding) {
            this.calculateFundingDisbursement();
        }

        this.validateFundingForm();
    }
}
